import React, { type FC } from 'react';
import { DynamicIcon, type IconName } from 'lucide-react/dynamic';

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface StatisticCardProps {
  icon?: IconName;
  title: string;
  metric: string;
  description: string;
}
const StatisticCard: FC<StatisticCardProps> = ({
  icon,
  title,
  metric,
  description,
}) => (
  <Card className='w-[200px]'>
    <CardHeader>
      <CardTitle className='flex items-center gap-1'>
        {icon && (
          <DynamicIcon
            name={icon}
            size={16}
          />
        )}
        {title}
      </CardTitle>
    </CardHeader>
    <CardContent className='text-2xl font-bold'>{metric}</CardContent>
    <CardFooter className='text-muted-foreground text-sm'>
      {description}
    </CardFooter>
  </Card>
);

export default StatisticCard;
